
const types = {
	SET_PINS: 'SET_PINS',
	SET_PIN_STATUS: 'SET_PIN_STATE',
	SET_START_STATUS: 'SET_START_STATE'
}

export default types